import { render } from "./LogoEmpresa.vue?vue&type=template&id=58529e3a&scoped=true"
import script from "./LogoEmpresa.vue?vue&type=script&lang=js"
export * from "./LogoEmpresa.vue?vue&type=script&lang=js"

import "./LogoEmpresa.vue?vue&type=style&index=0&id=58529e3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58529e3a"

export default script